export default class FeeScheduleTag {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: FeeScheduleTag): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): FeeScheduleTag {
    return new FeeScheduleTag("");
  }

  public fromJSON(value: string): FeeScheduleTag {
    return new FeeScheduleTag(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): FeeScheduleTag {
    return new FeeScheduleTag(this.value);
  }
}
